import { CALL_API } from "../context/constValues";
import { getAuthToken } from "../context/auth-context";

// ─── CAJA ENTRADA ────────────────────────────────────────────────────────────

export async function getAllCajaEntrada() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getallcajaentrada`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al cargar Caja de Entrada");
  return data.result;
}

export async function insertCajaEntrada(objeto) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/insertcajaentrada`, {
    method: "POST",
    headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
    body: JSON.stringify(objeto),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al insertar Caja de Entrada");
  return data.isSaved;
}

export async function updateCajaEntrada(id, objeto) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updatecajaentrada/${id}`, {
    method: "POST",
    headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
    body: JSON.stringify(objeto),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al actualizar Caja de Entrada");
  return data.isSaved;
}

export async function deleteCajaEntrada(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/deletecajaentrada/${id}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al eliminar");
  return data.isDeleted;
}

// ─── CAJA SALIDA ─────────────────────────────────────────────────────────────

export async function getAllCajaSalida() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getallcajasalida`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al cargar Caja de Salida");
  return data.result;
}

export async function insertCajaSalida(objeto) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/insertcajasalida`, {
    method: "POST",
    headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
    body: JSON.stringify(objeto),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al insertar Caja de Salida");
  return data.isSaved;
}

export async function updateCajaSalida(id, objeto) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updatecajasalida/${id}`, {
    method: "POST",
    headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
    body: JSON.stringify(objeto),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al actualizar Caja de Salida");
  return data.isSaved;
}

export async function deleteCajaSalida(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/deletecajasalida/${id}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || "Error al eliminar");
  return data.isDeleted;
}
